<template>
    <div class="order_content__header">
        <div class="order_content__header_main">
            <div ref="svgContainer" class="order_content__header_main_logo">
            </div>
            <div class="order_content__header_main_info">
                <div v-if="!isMobileScreen" class="order_content__header_main_info_number">
                    {{ numberOrder }}
                </div>
                <div v-if="isMobileScreen" class="order_content__header_time">
                    {{ timeOrder }}
                </div>
                <div class="order_content__header_main_info_name">
                    {{ nameLocation }}
                </div>
            </div>
        </div>
        <div v-if="!isMobileScreen" class="order_content__header_time">
            {{ timeOrder }}
        </div>
    </div>
    <div class="order_content_separator"/>
</template>

<script>
import insertSvg from "../../../mixins/insertSvg";
import {createHelpers} from "vuex-map-fields";
import {screenSize} from "../../../mixins/screenSize";

const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})

export default {
    name: "order_content_header",
    mixins: [insertSvg, screenSize],
    mounted() {
        if (this.activeItemMenuOrders.aggregator && this.activeItemMenuOrders.aggregator.icon) {
            this.insertSvg(this.activeItemMenuOrders.aggregator.icon);
        }
    },
    computed: {
        ...mOrders([
            'activeOrderFullInfo',
            'activeItemMenuOrders',
        ]),
        activeOrderId() {
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.id) {
                return this.activeOrderFullInfo.id;
            }
            return '';
        },
        numberOrder() {
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.pickup_code) {
                return this.activeOrderFullInfo.pickup_code;
            }
            return '';
        },
        nameLocation() {
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.pos_restaurant && this.activeOrderFullInfo.pos_restaurant.title) {
                return this.activeOrderFullInfo.pos_restaurant.title;
            }
            return '';
        },
        timeOrder() {
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.time && this.activeOrderFullInfo.time.erp_added) {
                let dateOrder=new Date(this.activeOrderFullInfo.time.erp_added);
                let hours = dateOrder.getHours();
                let minutes = dateOrder.getMinutes();
                if (hours < 10) {
                    hours = '0' + hours;
                }
                if (minutes < 10) {
                    minutes = '0' + minutes;
                }
                return hours + ':' + minutes;
            }
        }
    }
}
</script>
